export const authEndpoints = {
  forgotPasswordTempEmail: "/user-management/users/reset-password",
  confirmResetPassword: "/user-management/users/confirm-reset-password",
  validateSubDomain: "/entity/validate-sub-domain",
  login: "/session-management/login",
  completeNewPassword: "/session-management/complete-new-password",
  confirmForgotPassword: "/session-management/confirm-forgot-password",
  ssoInitiate: "/session-management/sso/initiate",
  callbackSso: "/session-management/sso/callback",
};
